export default __webpack_public_path__ + "static/media/bottle-blue.f479248b.svg";